import styled from "styled-components"

export const Container = styled.div`
    height: fit-content;
    width: ${props => props.width ?? '100%'};
    background: ${({theme, background}) => background ?? theme.container.primary.background};
    border: ${({theme}) => theme.container.primary.border};
    box-shadow: ${({boxShadow, theme}) => boxShadow ? theme.container.primary.boxShadow : 'none'};
    border-radius: 5px;
    padding: 16px 0;
    margin: ${props => props.margin ?? '0'};
`

export const Table = styled.table`
    width: 100%;
    border-collapse: collapse;
`

export const Title = styled.p`
    grid-area: title;
    display: flex;
    align-items: center;
    font-weight: 600;
    font-size: 16px!important;
    line-height: 16px;
    color: ${({color, theme}) => color ?? theme.title};
`

export const Actionbar = styled.div`
    height: 40px;
    align-items: center;
    display: grid;
    grid-template-columns: 50% 50%;
    grid-template-rows: 100%;
    grid-template-areas: 'title action';
`

export const Action = styled.div`
    grid-area: action;
    align-items: center;
    justify-self: end;
    svg{
        width: 16px;
        height: 16px;
        margin-left: 10px;
        stroke: ${({theme}) => theme.container.primary.text};
        color: ${({theme}) => theme.container.primary.text};
    }
`

export const Header = styled.thead``

export const HeaderCol = styled.th`
    background: ${({theme, background}) => background ?? theme.container.primary.background};
    width: ${props => props.width ?? 'unset'};
    text-align: start;
    padding: ${props => props.padding ?? '10px 12px 10px 12px'};
    color: ${({color, theme}) => color ?? theme.container.primary.text};
    border-bottom: 1px solid ${({theme}) => theme.container.primary.text};
    font-size: 12px;
    line-height: 15px;
    position: sticky;
    top: 0;
`

export const Body = styled.tbody`
    >tr {
        border-bottom: .5px solid #212121; 
        cursor: pointer;
        button:disabled {
            svg {
                color: #FFFFFF;
            }
        }
        svg {
            height: 10px;
            color: #000;
        }
    }
`

export const BodyCol = styled.td`
    padding-right: 25px;
    color: ${({theme}) => theme.container.primary.text};
    padding: ${props => props.padding ?? '10px 12px 10px 12px'};
    font-size: 12px;
    line-height: 15px;
`

export const Row = styled.div`
    width: 100%;
    display: flex;
`

export const Col = styled.div`
    min-width: 80px;
    width: 80px;
    padding: 10px 10px;
    font-weight: 600;
    font-size: 12px;
    line-height: 15px;
    color: ${({color, theme}) => color ?? theme.container.primary.text};
`

export const Close = styled.span`
    color: ${({theme}) => theme.container.secondary.title};
    float: right;
    font-size: 28px;
    font-weight: bold;
    font-size: 14px;
    :hover, :focus {
        color: black;
        text-decoration: none;
        cursor: pointer;
    }
`